import type { RefundOrigin } from '~/services/receipt-model-api/receipt-model-api.types';

export const COMMISSIONING_RESET_GROUP = 'installation_support';

export const REFUND_ORIGIN_LABEL = 'Para onde/de onde deve ser estornado o dinheiro?';

export const REFUND_ORIGIN_OPTIONS: { description: string; value: RefundOrigin }[] = [
  {
    description: 'Conta LTDA: O estorno será debitado diretamente da conta jurídica da empresa.',
    value: 'LTDA',
  },
  {
    description: 'Conta de Origem: O estorno será devolvido diretamente pela mesma via/conta '
      + 'de onde o desembolso original foi realizado.',
    value: 'ORIGIN',
  },
];

export const TRANSFER_REFUND_GROUP = 'fintech_backoffice:transfer:refund';

export const TRANSFER_REFUND_TERMINAL_STATUSES = ['paid', 'cancelled', 'canceled'] as const;

export const TRANSFER_CATEGORY_MAP = {
  commission_insurance: 'Comissão Seguro',
  equipment: 'Equipamento',
  financing: 'Financiamento',
} as const;

export const TRANSFER_RECIPIENT_MAP = {
  partner: 'Parceiro',
  supplier: 'Fornecedor',
} as const;

export const TRANSFER_STATUS_MAP = {
  awaiting_payment: 'Aguardando Pagamento',
  canceled: 'Cancelado',
  cancelled: 'Cancelado',
  fail: 'Falhou',
  paid: 'Pago',
  payment_blocked: 'Pagamento Bloqueado',
  pending: 'Pendente',
  waiting_send_payment: 'Aguardando Envio',
} as const;

export const TRANSFER_STATUS_COLOR_MAP = {
  awaiting_payment: 'info',
  canceled: 'secondary',
  cancelled: 'secondary',
  fail: 'danger',
  paid: 'success',
  payment_blocked: 'danger',
  pending: 'warning',
  waiting_send_payment: 'info',
} as const;

export const TRANSFER_KIND_MAP = {
  after_project_formalization: 'Após Formalização',
  after_validation_installation: 'Após Validação Instalação',
} as const;

export const TRANSFER_TABLE_COLUMNS = [
  { name: 'Destinatário', sort: false, value: 'recipient' },
  { name: 'Categoria', sort: false, value: 'category' },
  { name: 'Tipo', sort: false, value: 'kind' },
  { name: 'Valor', sort: true, value: 'value' },
  { name: 'Percentual', sort: true, value: 'percent' },
  { name: 'Status', sort: false, value: 'status' },
  { name: 'Observações', sort: false, value: 'blocked_reason' },
  { name: 'Ações', sort: false, value: 'actions' },
] as const;

export const TRANSFER_SUMMARY_CARDS = [
  {
    colorClass: 'text-success',
    key: 'transfers_paid',
    label: 'Transferências Pagas',
  },
  {
    colorClass: 'text-warning',
    key: 'transfers_pending',
    label: 'Transferências Pendentes',
  },
] as const;
